<script>
  import Link from '../../../utils/link';
  import Card from '../../../components/containers/card.html';
  import Avatar from '../../../components/containers/avatar.html';
  import moment from 'moment';

  export let event;

  let coordinator = event.coordinator ? `${event.coordinator.firstName} ${event.coordinator.lastName}` : 'Unassigned';
  let leader = event.leader ? `${event.leader.firstName} ${event.leader.lastName}` : 'Unassigned';
  let date = moment(event.date).format('dddd, MMMM Do, YYYY')

  function getEventLink() {
    return `/events/view/${event.id}`;
  }
</script>

<Card hover>
  <Link href={getEventLink()}>
    <div class="u--padall">
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-9">
        <h3>
          {event.name}
        </h3>
        <h4>{date} {event.startTime} - {event.endTime}</h4>
      </div>
    </div>
  </div>
  <hr />
  <div class="stat">
    <div class="grid-x">
      <div class="cell small-12 medium-2">
        <h4>Status</h4>
        <h5>{event.published ? 'Published' : 'Draft'}</h5>
      </div>
      <div class="cell small-12 medium-4">
        <div class="grid-x grid-margin-x">
          <div class="cell small-12 medium-4">
            <h4>Spots Left</h4>
            <h5>{event.open || 0}</h5>
          </div>
          <div class="cell small-12 medium-4">
              <h4>Capacity</h4>
              <h5>{event.constraintCapacityTotal || 0}</h5>
            </div>
          <div class="cell small-12 medium-4">
            <h4>Waitlist</h4>
            <h5>{event.waitlist || 0}</h5>
          </div>
        </div>
      </div>
      
      <div class="cell small-12 medium-3">
        <h4>Project Leader</h4>
        <h5>{leader}</h5>
      </div>
      <div class="cell small-12 medium-3">
        <h4>Program Coordinator</h4>
        <h5>{coordinator}</h5>
      </div>
    </div>
  </div>
  </Link>
</Card>


